export const CONTACT_FORM_EMAIL = "hello@kleanleaf.us";
export const CONTACT_FORM_SUCCESS_MESSAGE =
  "Thank you! Your message has been sent. Our team will follow up soon.";
export const CONTACT_FORM_ERROR_MESSAGE =
  "We couldn’t send your message right now. Please try again, or email us directly at hello@kleanleaf.us.";

const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";
const REQUEST_TIMEOUT_MS = 12000;
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const isValidAccessKey = (accessKey) => {
  return typeof accessKey === "string" && UUID_PATTERN.test(accessKey.trim());
};

export const submitContactForm = async (formData) => {
  const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

  if (!isValidAccessKey(accessKey)) {
    throw new Error("Web3Forms access key is missing or invalid.");
  }

  formData.set("access_key", accessKey.trim());

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(WEB3FORMS_ENDPOINT, {
      method: "POST",
      body: formData,
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`Web3Forms returned HTTP ${response.status}.`);
    }

    let data;
    try {
      data = await response.json();
    } catch (error) {
      throw new Error("Web3Forms returned invalid JSON.", { cause: error });
    }

    if (!data || data.success !== true) {
      throw new Error("Web3Forms rejected the submission.");
    }

    return data;
  } finally {
    window.clearTimeout(timeoutId);
  }
};
